import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";

//import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import { Button, Box, Divider } from "@mui/material";
import { Copyright } from "../../components/copyright";
import { Navigate } from "react-router-dom";
import { useContext, useState } from "react";
import GlobalStateContext from "../../globalstate/globalStateContext";
import CTDLogo from "../../components/logo/logo";

/*
const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));
*/
export default function Landing() {
  const [app, setApp] = useState(false);

  const global = useContext(GlobalStateContext);
  //console.log(global.userInfo);
  return (
    <>
      {global.userInfo.loggedIn && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "1rem",
            gap: "1rem",
            position: "relative",
          }}
        >
          <CTDLogo />
          <Divider style={{ width: "80%" }} />

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              margin: "3rem",
              gap: "3rem",
              position: "relative",
            }}
          >
            <Card sx={{ width: 150, height: 400, padding: "1rem" }}>
              <CardHeader title="UPLIFT" />
              <CardMedia
                component="img"
                sx={{ width: "150px", margins: "auto" }}
                image="iota-uplift-logo.png"
                alt="uplift"
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Find super-responders, improve ROI. Build an optimised plan.
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button
                  sx={{ position: "absolute", bottom: "1rem" }}
                  variant="contained"
                  color="primary"
                  aria-label="uplift"
                  disabled={global.userIs("uplift") ? false : true}
                  onClick={() => {
                    setApp("uplift");
                  }}
                >
                  Go
                </Button>
              </CardActions>
            </Card>

            <Card sx={{ width: 150, height: 400, padding: "1rem" }}>
              <CardHeader title="PREDICT" />
              <CardMedia
                component="img"
                sx={{ width: "150px" }}
                image="iota-predict-logo.png"
                alt="predict"
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Audience beyond rules. ML powered precision marketing that you
                  control.
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button
                  sx={{ position: "absolute", bottom: "1rem" }}
                  variant="contained"
                  color="primary"
                  aria-label="predict"
                  disabled={global.userIs("predict") ? false : true}
                  onClick={() => {
                    setApp("predict");
                  }}
                >
                  Go
                </Button>
              </CardActions>
            </Card>
            <Card sx={{ width: 150, height: 400, padding: "1rem" }}>
              <CardHeader title="TRIBES" />
              <CardMedia
                component="img"
                sx={{ width: "150px", margins: "auto" }}
                image="tribes.png"
                alt="insights"
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  Pro-active data discovery: a marketers best mate.
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button
                  sx={{ position: "absolute", bottom: "1rem" }}
                  variant="contained"
                  color="primary"
                  disabled={global.userIs("tribes") ? false : true}
                  aria-label="tribes"
                  onClick={() => {
                    setApp("tribes");
                  }}
                >
                  Go
                </Button>
              </CardActions>
            </Card>
            {global.userIs("subjecthero") && (
              <Card sx={{ width: 150, height: 400, padding: "1rem" }}>
                <CardHeader title="SUBJECT HERO" />
                <CardMedia
                  component="img"
                  sx={{ width: "150px", margins: "auto" }}
                  image="tribes.png"
                  alt="insights"
                />
                <CardContent>
                  <Typography variant="body2" color="text.secondary">
                    Subject Hero functionality coming soon.
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  <Button
                    sx={{ position: "absolute", bottom: "1rem" }}
                    variant="contained"
                    color="primary"
                    disabled={global.userIs("subjecthero") ? false : true}
                    aria-label="subjecthero"
                    onClick={() => {
                      setApp("subjecthero");
                    }}
                  >
                    Go
                  </Button>
                </CardActions>
              </Card>
            )}
          </Box>
          <Divider style={{ width: "80%" }} />
          <Button
            variant="contained"
            color="primary"
            aria-label="Load"
            onClick={() => {
              global.logout();
            }}
          >
            logout
          </Button>

          <Box>
            <img
              src="iota-logo.png"
              style={{ width: "100px", height: "100%", objectFit: "contain" }}
              alt="logo"
            />
          </Box>
          <Box>
            <Copyright />
          </Box>

          {app === "uplift" && <Navigate replace to="/uplift" />}
          {app === "predict" && <Navigate replace to="/predict" />}
          {app === "tribes" && <Navigate replace to="/tribes" />}
          {app === "subjecthero" && <Navigate replace to="/subjecthero" />}
        </Box>
      )}
    </>
  );
}
/*      {app === 'insights' && <Navigate replace to="/insights" />}
      

        <Card sx={{ width: 200, height: 500, padding: "1rem" }}>
          <CardHeader title="INSIGHTS" />
          <CardMedia
            component="img"
            sx={{ width: "200px", margins: "auto" }}
            image="insights.png"
            alt="insights"
          />
          <CardContent>
            <Typography variant="body2" color="text.secondary">
              Profiles, stats and nuggets - 'always on' customer insights.
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            <Button
              sx={{ position: "absolute", bottom: "1rem" }}
              variant="contained"
              color="primary"
              aria-label="insights"
              onClick={() => {
                setApp("insights");
              }}
            >
              Go
            </Button>
          </CardActions>
        </Card>
*/
